import { hasCapability, type User } from "../base";

export const conversationAssignment = {
  update: (user: User) => hasCapability(user, "conversationAssignment.update"),
};
